import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  padding: 45px 20px;
  color: ${(props) => props.theme.color};
  text-align: center;
  cursor: default;

  ${(props) =>
    props.fullmode &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex-grow: 1;
    `}
`;

export const Content = styled.div`
  display: inline-block;
`;

export const Icon = styled.i`
  display: block;
  width: 40px;
  height: 40px;
  font-size: 40px;
  margin: 0 auto 10px;
`;

export const Text = styled.div`
  font-size: 22px;
  line-height: 1.2;
  font-weight: 400;
`;
